import React, { memo } from 'react'

import i18n from 'live/services/i18n'

import { threatConsequenceWidth, barrierWidth, THREAT_COSNEQUENCE_GAP_X } from '../../../../../../../utils/constants'
import { AddButtonContainer, PopupSVG, StyledAddButton } from './styles'

type IProps = {
    type: 'THREAT' | 'CONSEQUENCE'
    x: number
    y: number
    onAddRequest: (type: 'THREAT' | 'CONSEQUENCE') => void
    customText?: string
    threatConsequenceLength: number
}

const AddThreatConsequence: React.FC<IProps> = ({ type, x, y, onAddRequest, customText, threatConsequenceLength }) => {
    return (
        <AddButtonContainer
            transform={`translate(${(type === 'THREAT'
                ? x - threatConsequenceWidth - THREAT_COSNEQUENCE_GAP_X + 10
                : x + THREAT_COSNEQUENCE_GAP_X + 10) +
                (threatConsequenceLength < 2 ? 0 : threatConsequenceWidth / 4)}, ${y - 120})`}
            cursor="pointer"
            onClick={() => onAddRequest(type)}
        >
            {threatConsequenceLength > 1 && (
                <PopupSVG transform={`translate(${type === 'THREAT' ? -155 : 65}, -4)`}>
                    <g transform={type === 'THREAT' ? 'translate(148, 4)' : 'translate(2, 4)'}>
                        <rect
                            className="svg-popup-helper"
                            height={16}
                            width={16}
                            transform="rotate(45)"
                            rx={2}
                            ry={2}
                        />
                    </g>
                    <foreignObject width={150} height={30}>
                        <div className={type}>{i18n('Add') + ' ' + i18n(type).toLowerCase()}</div>
                    </foreignObject>
                </PopupSVG>
            )}
            <StyledAddButton
                x={type === 'THREAT' ? 10 : 25}
                width={threatConsequenceLength > 1 ? 24 : 119}
                height={24}
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <div>
                    <i className="far fa-plus" />
                    {threatConsequenceLength > 1 ? '' : customText ?? i18n(type)}
                </div>
            </StyledAddButton>
        </AddButtonContainer>
    )
}

export default memo(AddThreatConsequence)
